<template>
    <v-card class="rounded-xl elevation-2 overflow-hidden" max-width="1200">
        <v-toolbar flat color="white" class="px-2">
            <v-avatar color="primary lighten-5" size="40" class="mr-3">
                <v-icon color="primary">work</v-icon>
            </v-avatar>
            <v-toolbar-title class="font-weight-bold blue--text text--darken-3">
                HISTORIAL LABORAL
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="fuModalOpen()">
                <v-icon>add</v-icon> Agregar
            </v-btn>
        </v-toolbar>

        <v-divider></v-divider>
        <v-card-text class="pa-0">
            <v-data-table
                :headers="dTable.headers"
                :items="dDtlLaboralAlumnos"
                :loading="dTable.loading"
                class="custom-table"
                hide-default-footer
                :items-per-page="-1"
            >
                <template v-slot:loading>
                    <v-skeleton-loader type="table-row@3"></v-skeleton-loader>
                </template>
                <template v-slot:no-data>
                    <div class="pa-10 d-flex flex-column align-center">
                        <v-icon size="64" color="grey lighten-2">signal_cellular_no_sim</v-icon>
                        <div class="text-h3 grey--text text--lighten-1 mt-2"><strong>No hay registros para mostrar.</strong></div>
                    </div>
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn @click="fuEdit(item)" icon v-bind="attrs" v-on="on" class="mr-1">
                                <v-icon>edit</v-icon>
                            </v-btn>
                        </template>
                        <span>Editar</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn @click="fuDelete(item)" icon v-bind="attrs" v-on="on">
                                <v-icon>clear</v-icon>
                            </v-btn>
                        </template>
                        <span>Eliminar</span>
                    </v-tooltip>
                </template>
                <template v-slot:[`item.empresaNombre`]="{ item }">
                    <div class="d-flex align-center py-2">
                        <v-avatar size="32" color="blue-grey lighten-5" class="mr-3">
                            <v-icon color="blue-grey text--darken-2">apartment</v-icon>
                        </v-avatar>
                        <span class="font-weight-bold grey--text text--darken-3">{{ item.empresaNombre }}</span>
                    </div>
                </template>
                <template v-slot:[`item.tipo`]="{ item }">
                    <v-chip
                        :color="item.tipo === 'Privada' ? 'blue lighten-5' : 'orange lighten-5'"
                        :class="item.tipo === 'Privada' ? 'blue--text' : 'orange--text'"
                        class="font-weight-bold" small label 
                    >
                        {{ item.tipo }}
                    </v-chip>
                </template>
                <template v-slot:[`item.fechaCreacion`]="{ item }">
                    <div class="text-caption">
                        <v-icon small color="grey" class="mr-1">calendar_month</v-icon>
                        {{ fuFormatDate(item.fechaCreacion) }}
                    </div>
                </template>
            </v-data-table>
        </v-card-text>
        <v-navigation-drawer v-model="dModal.dialog" fixed right width="450" class="elevation-10">
            <div class="d-flex flex-column">
                <v-toolbar flat color="primary" dark>
                    <v-toolbar-title class="font-weight-bold">
                        {{ dDtlLaboralAlumno.id ? 'Editar' : 'Agregar' }} Registro Laboral
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="dModal.dialog = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-divider></v-divider>
                <v-card-text class="flex-grow-1 overflow-y-auto pa-3">
                    <v-form ref="refForm" v-model="dModal.valid" lazy-validation>
                        <v-row dense>
                            <v-col cols="12">
                                <v-text-field
                                    v-model="dDtlLaboralAlumno.empresaNombre"
                                    label="Nombre de la Empresa"
                                    filled
                                    dense
                                    prepend-inner-icon="apartment"
                                    :rules="[v => !!v || 'Campo requerido']"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12">
                                <v-autocomplete
                                    v-model="dDtlLaboralAlumno.ubigeo" label="Ubigeo de Referencia (Depa/Prov/Dist)"
                                    :items=dUbigeos
                                    :rules="[v => !!v || 'Campo requerido']"
                                    filled dense clearable prepend-inner-icon="location_on">
                                </v-autocomplete>
                            </v-col>
                            <v-col cols="12">
                                <v-select
                                    v-model="dDtlLaboralAlumno.tipo"
                                    :items="['Dependiente', 'Independiente', 'Emprendimiento', 'Informal', 'Otro']"
                                    label="Tipo de Empresa"
                                    filled
                                    dense
                                    prepend-inner-icon="castle"
                                    :rules="[v => !!v || 'Campo requerido']"
                                ></v-select>
                            </v-col>
                            <v-col cols="12">
                                <v-autocomplete
                                    v-model="dDtlLaboralAlumno.sector"
                                    :items="dSectors"
                                    label="Sector"
                                    filled
                                    dense
                                    prepend-inner-icon="auto_awesome_mosaic"
                                    :rules="[v => !!v || 'Campo requerido']"
                                ></v-autocomplete>
                            </v-col>
                            <v-col cols="12">
                                <v-text-field
                                v-model="dDtlLaboralAlumno.cargo"
                                label="Cargo desempeñado"
                                filled
                                dense
                                prepend-inner-icon="military_tech"
                                :rules="[v => !!v || 'Campo requerido']"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12">
                                <v-select
                                    v-model="dDtlLaboralAlumno.turno"
                                    :items="['Mañana', 'Tarde', 'Noche', 'Rotativo']"
                                    label="Turno"
                                    filled
                                    dense
                                    prepend-inner-icon="brightness_4"
                                    :rules="[v => !!v || 'Campo requerido']"
                                ></v-select>
                            </v-col>
                            <v-col cols="12">
                                <v-select
                                    v-model="dDtlLaboralAlumno.dias"
                                    :items="['L-V', 'L-S', 'S-D', 'Otro']"
                                    label="Días laborables"
                                    filled
                                    dense
                                    prepend-inner-icon="date_range"
                                    :rules="[v => !!v || 'Campo requerido']"
                                ></v-select>
                            </v-col>
                            <v-col cols="12">
                                <v-switch v-model="dDtlLaboralAlumno.esRelacionado" label="¿El trabajo está relacionado con la carrera?" inset dense class="ma-0"></v-switch>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>
                <v-divider></v-divider>
                <div class="pa-4 bg-grey lighten-4">
                    <v-btn 
                        block
                        color="primary" 
                        size="large"
                        class="text-none rounded-lg py-6" 
                        elevation="2"
                        :loading="dModal.loading"
                        @click="fuSave"
                    >
                        <v-icon> save</v-icon> Guardar
                    </v-btn>
                </div>
            </div>
        </v-navigation-drawer>
    </v-card>
</template>
<script>
import gql from 'graphql-tag';
import Swal from 'sweetalert2';
import {dUbigeos} from '@/helpers/ubigeos.js';
import {fuFormatDate} from '@/helpers/index.js';

const QUERY_LABORAL = gql`
    query dtllaboralalumnoByIdAlumno($IdAlumno: Int!) {
        dtllaboralalumnoByIdAlumno(IdAlumno: $IdAlumno) {
            id
            empresaNombre
            tipo
            sector
            cargo
            ubigeo
            turno
            dias
            esRelacionado
            fechaCreacion
        }
    }
`;
const MUTATION_DELETE = gql`
    mutation dtllaboralalumnoDelete($id: ID!) {
        dtllaboralalumnoDelete(id: $id) {
            id
        }
    }
`;
export default {
    name: 'DtlLaboralAlumno',
    props: {
        pIdAlumno: {
            type: Number,
            required: true,
        }
    },
    mounted(){
        if (this.pIdAlumno)
            this.fuLoad();
    },
    data: () => ({
        dModal: {
            dialog: false,
            loading: false,
            valid: true
        },
        dTable: {
            headers: [
                {value: 'actions', text: 'Acción', sortable: false, align: 'start'},
                {value: 'empresaNombre', text: 'Empresa'},
                {value: 'tipo', text: 'tipo'},
                {value: 'sector', text: 'sector'},
                {value: 'cargo', text: 'cargo'},
                {value: 'fechaCreacion', text: 'Registrado'},
            ],
            loading: false,
        },
        dDtlLaboralAlumnos: [],
        dDtlLaboralAlumno: {
            IdAlumno: null,
            empresaNombre: '',
            tipo: '',
            sector: '',
            cargo: '',
            turno: '',
            dias: '',
            esRelacionado: false,
        },
        dSectors: [
            {value: 'Comercio', text:'Comercio: (Ventas minoristas, mayoristas, tiendas online).'},
            {value: 'Servicios Profesionales', text:'Servicios Profesionales: (Consultoría, diseño, contabilidad, legal, soporte técnico).'},
            {value: 'Turismo y Gastronomía', text:'Turismo y Gastronomía: (Hoteles, restaurantes, agencias de viaje).'},
            {value: 'Tecnología y Sistemas', text:'Tecnología y Sistemas: (Desarrollo de software, IT, telecomunicaciones).'},
            {value: 'Salud y Bienestar', text:'Salud y Bienestar: (Clínicas, farmacias, cuidado personal, deporte).'},
            {value: 'Educación', text:'Educación: (Instituciones educativas, capacitación, tutorías).'},
            {value: 'Industria y Manufactura', text:'Industria y Manufactura: (Fábricas, producción de bienes, construcción).'},
            {value: 'Administración Pública', text:'Administración Pública: (Entidades del Estado, municipalidades).'},
            {value: 'Banca y Finanzas', text:'Banca y Finanzas: (Bancos, seguros, cajas municipales).'},
            {value: 'Transporte y Logística', text:'Transporte y Logística: (Delivery, carga, transporte de pasajeros).'},
            {value: 'Otro', text:'Otro: (Para sectores muy específicos o nichos).'}
        ],
        dUbigeos: dUbigeos,
    }),
    methods: {
        fuFormatDate,
        async fuLoad() {
            this.dTable.loading = true;
            try {
                const { data } = await this.$apollo.query({
                    query: QUERY_LABORAL,
                    variables: {
                        IdAlumno: this.pIdAlumno 
                    },
                    fetchPolicy: 'no-cache'
                });
                this.dDtlLaboralAlumnos = data.dtllaboralalumnoByIdAlumno;
            } catch (error) {
                console.error("Error cargando datos laborales:", error);
            } finally {
                this.dTable.loading = false;
            }
        },
        fuEdit(item) {
            this.dDtlLaboralAlumno = JSON.parse(JSON.stringify(item));
            this.dDtlLaboralAlumno.IdAlumno = this.pIdAlumno;
            
            if (this.$refs.refForm) this.$refs.refForm.resetValidation();
            this.dModal.dialog = true;
        },
        fuModalOpen() {
            this.dDtlLaboralAlumno = {
                id: null,
                IdAlumno: this.pIdAlumno,
                empresaNombre: '',
                tipo: '',
                sector: '',
                cargo: '',
                ubigeo: '',
                turno: '',
                dias: '',
                esRelacionado: false,
            };
            if (this.$refs.refForm) this.$refs.refForm.resetValidation();
            this.dModal.dialog = true;
        },
        async fuSave() {
            if (!this.$refs.refForm.validate()) return;

            this.dModal.loading = true;
            const isEdit = !!this.dDtlLaboralAlumno.id;
            
            const MUTATION = isEdit ? gql`
                    mutation dtllaboralalumnoUpdate($id: ID!, $input: dtllaboralalumnoUpdateInput!) {
                        dtllaboralalumnoUpdate(id: $id, input: $input) { id }
                    }
                ` : gql`
                    mutation dtllaboralalumnoCreate($input: dtllaboralalumnoCreateInput!) {
                        dtllaboralalumnoCreate(input: $input) { id }
                    }
                `;

            try {
                const variables = isEdit 
                    ? { id: String(this.dDtlLaboralAlumno.id), input: this.fuPrepareInput(this.dDtlLaboralAlumno) }
                    : { input: this.fuPrepareInput(this.dDtlLaboralAlumno) };

                const { data } = await this.$apollo.mutate({
                    mutation: MUTATION,
                    variables: variables
                });

                if (data) {
                    await this.fuLoad();
                    this.dModal.dialog = false;
                    Swal.fire('¡Éxito!', isEdit ? 'Registro actualizado.' : 'Registro guardado.', 'success');
                }
            } catch (error) {
                console.error(error);
                Swal.fire('Error', 'No se pudo procesar la solicitud.', 'error');
            } finally {
                this.dModal.loading = false;
            }
        },
        fuPrepareInput(obj) {
            return {
                IdAlumno: parseInt(this.pIdAlumno),
                empresaNombre: obj.empresaNombre,
                tipo: obj.tipo,
                sector: obj.sector,
                cargo: obj.cargo,
                ubigeo: obj.ubigeo,
                turno: obj.turno,
                dias: obj.dias,
                esRelacionado: !!obj.esRelacionado
            };
        },
        async fuDelete(item) {
            const result = await Swal.fire({
                title: '¿Estás seguro?',
                text: `Se eliminará el registro de la empresa ${item.empresaNombre}. Esta acción no se puede deshacer.`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sí, eliminar',
                cancelButtonText: 'Cancelar',
                reverseButtons: true
            });

            if (result.value || result.isConfirmed) {                
                this.dTable.loading = true;
                try {
                    await this.$apollo.mutate({
                        mutation: MUTATION_DELETE,
                        variables: { id: String(item.id) }
                    });
                    
                    await this.fuLoad();
                    Swal.fire('Eliminado', 'El registro ha sido borrado con éxito.', 'success');
                } catch (error) {
                    console.error("Error al eliminar:", error);
                    Swal.fire('Error', 'No se pudo eliminar el registro.', 'error');
                } finally {
                    this.dTable.loading = false;
                }
            }
        },
    }
}
</script>
<style scoped>
.custom-table >>> thead th {
  background-color: #2980b9 !important;
  color: #f8fafc !important;
  text-transform: uppercase;
  font-size: 0.75rem !important;
  font-weight: 700 !important;
  letter-spacing: 0.05em;
}
.custom-table >>> tbody tr:nth-of-type(even) {
  background-color: #f5f5f5; /* Un gris muy claro */
}
.custom-table >>> tbody tr:hover {
  background-color: #eeeeee !important;
  transition: background-color 0.2s ease;
}

.custom-table >>> td {
  border-bottom: 1px solid #f1f5f9 !important;
}
</style>
